import React from 'react';
import clsx from 'clsx';

const variants = {
  primary: 'bg-gradient-to-br from-[var(--neon-cyan)] to-[var(--neon-cyan-dim)] text-[#050a15] shadow-[0_4px_25px_rgba(0,240,255,0.3)] hover:shadow-[0_12px_40px_rgba(0,240,255,0.4),0_0_60px_rgba(0,240,255,0.15)]',
  secondary: 'bg-[var(--bg-glass)] text-[var(--text-primary)] border border-[var(--border-color)] backdrop-blur-md hover:border-[var(--neon-cyan)] hover:text-[var(--neon-cyan)]',
  ghost: 'bg-transparent text-[var(--neon-cyan)] border border-[var(--neon-cyan)]/30 hover:bg-[var(--neon-cyan)]/10',
  danger: 'bg-gradient-to-br from-[var(--neon-pink)] to-[#c0224f] text-white shadow-[0_4px_25px_rgba(255,42,109,0.3)]',
  violet: 'bg-gradient-to-br from-[var(--neon-violet)] to-[var(--neon-violet-dim)] text-white shadow-[0_4px_25px_rgba(168,85,247,0.3)]',
};

const sizes = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-5 py-2 text-sm',
  lg: 'px-6 py-3 text-base',
  xl: 'px-8 py-4 text-lg',
};

export default function NeonButton({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconRight,
  href,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
  ...rest
}) {
  const cls = clsx(
    'inline-flex items-center justify-center gap-2 font-semibold tracking-wide rounded-full transition-all duration-300 relative overflow-hidden cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed hover:-translate-y-0.5 active:translate-y-0',
    'before:absolute before:inset-0 before:bg-gradient-to-r before:from-transparent before:via-white/15 before:to-transparent before:-translate-x-full before:transition-transform before:duration-500 hover:before:translate-x-full',
    variants[variant],
    sizes[size],
    className
  );

  const content = (
    <>
      {icon && <span className="inline-flex shrink-0">{icon}</span>}
      <span>{children}</span>
      {iconRight && <span className="inline-flex shrink-0">{iconRight}</span>}
    </>
  );

  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} disabled={disabled} className={cls} {...rest}>
      {content}
    </button>
  );
}